import { useState, useEffect } from 'react';

import { Box, Typography, TextField, Button, Select, FormControl, InputLabel, MenuItem } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PasswordIcon from '@mui/icons-material/Password';

import Popup from '../Popup.jsx';

import { getUsers, updateUser, creatUser, deleteUser, password } from '../../api/users.js'

import { useData } from '../../hooks/DataProvider.jsx';
import translations from '../../scripts/translations.json';


function CmptItemsList({ items, setActiveItem, itemsListName }) {

    const { language } = useData();
    // const btns = translations.button[language];
    const page = translations.components.users[language];


    const create = () => {
        setActiveItem({ _id: "new", firstName: '', lastName: '', email: '', login: '', role: 'client' })
    }

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant='h6' sx={{ mb: 2 }}>
                    {page.users}
                </Typography>

                <Button variant='outlined' onClick={create} size='small'> <AddIcon /> </Button>
            </Box>

            <Box>
                {items.map((i) => (
                    <Box key={i._id}
                        sx={{ border: '1px solid #ccc', marginBottom: 2, borderRadius: 1, p: 2, cursor: 'pointer', direction: 'row', display: 'flex', gap: 2, alignItems: 'center' }}
                        onClick={() => setActiveItem(i)}
                    >
                        <Typography variant="subtitle1">{i?.firstName}</Typography>
                        <Typography variant="subtitle1">{i?.lastName}</Typography>
                        <Typography variant="subtitle1">{i?.email}</Typography>
                    </Box>
                ))}
            </Box>
        </>

    );
}

function CmptActiveItem({ activeItem, setActiveItem, items, setItems, collection, activeItemName }) {

    const { language } = useData();
    // const btns = translations.button[language];
    const page = translations.components.users[language];


    const [popupData, setPopupData] = useState({
        open: false,
        code: null,
        id: null,
        fn: null,
    });


    const [viewPassword, setViewPassword] = useState(false)
    const [newPasswort, setNewPasswort] = useState('')

    const role = localStorage.getItem('role') !== "admin" ? true : false

    const handleChange = (e) => {
        const { id, value } = e.target
        setActiveItem({ ...activeItem, [id]: value })
        // console.log(activeItem)
    }

    const handleChangeSelect = (event) => {
        setActiveItem({ ...activeItem, role: event.target.value })
    };



    const handleUpdate = async () => {

        if (activeItem._id === "new") {
            const rs = await creatUser(activeItem)
            if (rs) {
                console.log("L'objet à aider créé")
                let tempItem = { ...activeItem, _id: rs._id }
                setItems([...items, tempItem].sort((a, b) => a.firstName.localeCompare(b.firstName)))
                setActiveItem(tempItem)
                // handlePassword()
            }
            else {
                console.log("Erreur lors de la création de l'objet à aider")
            }
        }

        else {
            const rs = await updateUser(activeItem)
            if (rs) {
                console.log("L'objet à aider mise à jour")
                let tempItem = { ...activeItem, _id: rs._id }
                let tempArr = items.filter((item) => item._id !== rs._id)
                setItems([...tempArr, tempItem].sort((a, b) => a.firstName.localeCompare(b.firstName)))
            }
            else {
                console.log("Erreur lors de la mise à jour de l'objet à aider")
            }
        }

    }


    const handelDeleteUser = async (id) => {

        const rs = await deleteUser(id)
        if (rs) {
            console.log(`L'utilisateur ${activeItem.firstName} ${activeItem.lastName} a été supprimé`)
            setItems((prev) => prev.filter((item) => item._id !== activeItem._id))
            setActiveItem({})
        } else {
            console.log("Erreur lors de la suppression de l'utilisateur")
        }

    }

    const handelDelete = () => {
        setPopupData({
            open: true,
            code: 'deleteUserConfirmation',
            id: activeItem._id,
            fn: handelDeleteUser,
            types: {
                hasCancel: true,
                hasConfirm: true,
            }
        });
    }



    const handlePassword = async () => {
        const rs = await password({ "userId": activeItem._id })
        if (rs) {
            setViewPassword(true)
            setNewPasswort(rs.new_password)
            console.log('Mot de passe a été mis à jour')
        }
    }


    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant='h6' sx={{ mb: 0 }}>
                    {page.user}
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', }}>
                    <Typography variant='body2' sx={{ mb: 0 }} display={viewPassword === false ? 'none' : ''} disabled={role} >Пароль: {newPasswort}</Typography>
                    <Button variant='outlined' onClick={handleUpdate} size='small' disabled={role}> <SaveAltIcon /> </Button>
                    <Button variant='outlined' onClick={handlePassword} size='small' disabled={role}> <PasswordIcon /> </Button>
                    <Button variant='outlined' onClick={handelDelete} size='small' disabled={role}> <DeleteOutlineIcon /> </Button>
                    <Button variant='outlined' onClick={() => setActiveItem({})} size='small'> <CloseIcon /> </Button>
                    {/* <Button variant='outlined' onClick={() => console.log(activeItem)} size='small'> Print </Button> */}
                </Box>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, p: 0, mb: 2 }}>
                <TextField
                    id={'firstName'}
                    label="Prenom"
                    variant="outlined"
                    value={activeItem?.firstName}
                    onChange={(e) => handleChange(e)}
                    autoComplete="off"
                />

                <TextField
                    id={'lastName'}
                    label="Nom"
                    variant="outlined"
                    value={activeItem?.lastName}
                    onChange={(e) => handleChange(e)}
                    autoComplete="off"
                />

                <TextField
                    id={'login'}
                    label="Login"
                    variant="outlined"
                    value={activeItem?.login}
                    onChange={(e) => handleChange(e)}
                    autoComplete="off"
                />

                <TextField
                    id={'email'}
                    label="Email"
                    variant="outlined"
                    value={activeItem?.email}
                    onChange={(e) => handleChange(e)}
                    autoComplete="off"
                />

                <FormControl fullWidth>
                    <InputLabel id="role">Rôle</InputLabel>
                    <Select
                        labelId="role"
                        id="role"
                        value={activeItem?.role}
                        label="Rôle"
                        onChange={handleChangeSelect}
                        defaultValue={"client"}
                        autoComplete="off"
                    >
                        <MenuItem value={"client"}>Client</MenuItem>
                        <MenuItem value={"manager"}>Manager</MenuItem>
                        <MenuItem value={"admin"} disabled={role}>Admin</MenuItem>
                    </Select>
                </FormControl>

                {popupData.open && <Popup popupData={popupData} setPopupData={setPopupData} />}

            </Box>
        </>)
}


const Users = () => {

    const [items, setItems] = useState([])
    const [activeItem, setActiveItem] = useState({})
    let collection = "users"
    let itemsListName = "Liste des utilisateurs"
    let activeItemName = "Utilisateur"


    useEffect(() => {
        const fetchUsers = async () => {
            const users = await getUsers();
            if (users) {
                setItems(users);
            }
        }
        fetchUsers();
    }, []);



    return (
        <>


            {activeItem?._id ?
                <>
                    <CmptActiveItem
                        activeItem={activeItem}
                        setActiveItem={setActiveItem}
                        items={items}
                        setItems={setItems}
                        activeItemName={activeItemName}
                        collection={collection}
                    />

                </>
                :
                <>
                    <CmptItemsList items={items} setActiveItem={setActiveItem} itemsListName={itemsListName} />
                </>
            }



        </>

    );
}

export default Users;
